class DispatchTimer extends HTMLElement {
  constructor() {
    super();
    this.cutoffTime = this.dataset.cutoff;
    this.blockedDays = this.dataset.blockedDays ? this.dataset.blockedDays.split(',').map(d => d.trim().toLowerCase()) : [];
    this.blockedDates = this.dataset.blockedDates ? this.dataset.blockedDates.split(',').map(d => d.trim()) : [];
    this.timeElements = this.querySelectorAll('.js-dispatch-timer-time');

    if (!this.cutoffTime || this.timeElements.length === 0) return;

    this.initTimer();
  }

  initTimer() {
    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date();
    
    // Check if today is a blocked day (e.g. Saturday or Sunday)
    const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const currentDayName = dayNames[now.getDay()];
    
    // Check if today is a blocked date (DD-MM-YYYY or DD/MM/YYYY)
    const dateStrDash = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}`;
    const dateStrSlash = `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()}`;
    
    const isBlocked = this.blockedDays.includes(currentDayName) || 
                      this.blockedDates.includes(dateStrDash) || 
                      this.blockedDates.includes(dateStrSlash);

    const [cutoffHour, cutoffMinute] = this.cutoffTime.split(':').map(Number);
    let targetDate = new Date();
    targetDate.setHours(cutoffHour, cutoffMinute, 0, 0);

    let isPastCutoff = false;
    if (now >= targetDate) {
      isPastCutoff = true;
      targetDate.setHours(23, 59, 59, 999);
    }

    if (isBlocked) {
      this.style.display = 'none';
      return;
    } else {
      this.style.display = 'block';
    }

    const textBefore = this.querySelector('.js-dispatch-timer-text-before');
    const textAfter = this.querySelector('.js-dispatch-timer-text-after');

    if (isPastCutoff) {
      if (textBefore) textBefore.style.display = 'none';
      if (textAfter) textAfter.style.display = 'inline';
    } else {
      if (textBefore) textBefore.style.display = 'inline';
      if (textAfter) textAfter.style.display = 'none';
    }

    const diff = targetDate.getTime() - now.getTime();
    
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((diff % (1000 * 60)) / 1000);

    const timeString = `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    this.timeElements.forEach(el => {
      el.textContent = timeString;
    });
  }
}

customElements.define('dispatch-timer', DispatchTimer);
